// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3aITA","title":"Info_title__19l43","selects":"Info_selects__Q4rfb","requiredAsterisk":"Info_requiredAsterisk__2HRc9"};